import { useQuery } from '@tanstack/react-query';
import type { Dayjs } from 'dayjs';
import { http } from 'services/http';
import { TRIPS_LOAD_BY_WAREHOUSES_GET } from 'api/query-keys';
import type { TGetTripsLoadByWarehousesRes } from 'api/swagger';
import { setFiltersToQs } from 'shared/utils/filters/set-filters-to-qs';

interface ITripsLoadByWarehousesFilter {
  date?: Dayjs[];
  loadingWarehouseId?: number;
  unloadingWarehouseId?: number;
}

interface IParams {
  filters: ITripsLoadByWarehousesFilter;
}

export const useGetTripsLoadByWarehouses = ({ filters }: IParams) => {
  const qs = new URLSearchParams();
  setFiltersToQs<ITripsLoadByWarehousesFilter>(qs, filters);

  return useQuery({
    queryKey: [TRIPS_LOAD_BY_WAREHOUSES_GET, { filters }],
    queryFn: async () => {
      const { data } = await http.get<TGetTripsLoadByWarehousesRes>(
        `/v1/statistics/trips-load-by-warehouses?${qs.toString()}`,
      );
      return data;
    },
    enabled: Boolean(filters.loadingWarehouseId && filters.unloadingWarehouseId),
    retry: false,
    refetchOnWindowFocus: false,
  });
};
